export default function isCheckoutPage() {
    const location = document.location.pathname;
    const variations = [
        '/kassa/',
        '/kassa',
        'kassa',
        'kassa/',
        '/presentkortskassa/',
        '/presentkortskassa',
        'presentkortskassa',
        'presentkortskassa/',
        '/varukorg/',
        '/varukorg',
        'varukorg',
        'varukorg/'
    ];

    return variations.indexOf(location) > -1;
}